import AttachmentUploadQueueItem from '../../types/AttachmentUploadQueueItem';
import { AttachmentState } from 'owa-attachment-full-data';

export default function removeRelatedItemFromUploadQueue(
    attachmentState: AttachmentState,
    container: AttachmentUploadQueueItem[]
) {
    for (let i = 0; i < container.length; i++) {
        const item: AttachmentUploadQueueItem = container[i];
        if (item.attachmentState.attachmentId === attachmentState.attachmentId) {
            if (item.onAttachmentCanceledOrFailedCallback) {
                item.onAttachmentCanceledOrFailedCallback(true /* canceled */);
            }
            container.splice(i, 1);
        }
    }
}
